import { useAuthStore } from '~/modules/auth/stores/authStore';
import { useUserStore } from '~/modules/user/stores/userStore';
import type { TAuthErrors } from "~/modules/auth/types/auth";
import extractResponseErrors from "~/modules/auth/utils/extractResponseErrors";

export const useAuth = () => {
  const { $api } = useNuxtApp() as NuxtAppType;

  const authStore = useAuthStore();
  const userStore = useUserStore();

  const errorMessage = ref('');
  const errors = reactive<TAuthErrors>({});

  const setupCurrentUser = async () => {
    try {
      const response = await $api.auth.current();
      if (response.success) {
        authStore.authorize(response.data.id);
        userStore.setUserData(response.data);
      }
    } catch (e) {
      console.warn('Ошибка при получении текущего пользователя: ' + e);
      console.log(e);
    }
  };

  const sendSMSCode = async (phone: string) => {
    try {
      const response = await $api.auth.sendSMS(phone);

      return response
    } catch (e: any) {
      if (e.response?._data?.errors && Object.keys(e.response?._data?.errors).length) {
        Object.assign(errors, extractResponseErrors(e));
      } else {
        errorMessage.value = e.response?._data?.message;
      }

      throw new Error('Ошибка регистрации');
    }
  }

  const checkPhoneExist = async (phone: string) => {
    try {
      const response = await $api.auth.checkPhone(phone);

      if (response.data.exists) {
        return true;
      }

      return false;
    } catch (e: any) {
      if (e.response?._data?.errors && Object.keys(e.response?._data?.errors).length) {
        Object.assign(errors, extractResponseErrors(e));
      } else {
        errorMessage.value = e.response?._data?.message;
      }

      throw new Error('Ошибка регистрации');
    }
  }

  return {
    errorMessage,
    setupCurrentUser,
    checkPhoneExist,
    sendSMSCode,
  };
};
